// @ts-nocheck
import { distance, Interval, Key, Note, Scale, transpose } from 'tonal';
import { mapNumberToInterval, shuffleArray } from "./helpers";

const pt = console.log

function parseNote(str: string) {
    const firstChar = str.charAt(0); // 获取首字符
    const lastChar = str.charAt(str.length - 1); // 获取尾字符
    const middleChars = str.slice(1, str.length - 1); // 获取中间字符（从第二个字符到倒数第二个字符）

    return {
        letter: firstChar,
        oct: lastChar,
        accidentals: middleChars
    };
}

function getRandomN(arr, n) {
    if (n > arr.length) {
        throw new Error("n 不能大于数组的长度");
    }

    const result = [];
    const tempArr = [...arr]; // 创建原数组的副本

    for (let i = 0; i < n; i++) {
        const randomIndex = Math.floor(Math.random() * tempArr.length);
        result.push(tempArr[randomIndex]);
        tempArr.splice(randomIndex, 1); // 从临时数组中移除已选择的元素
    }

    return result;
}


export const noteAccInMajor = (note: string, key: string) => {
    // 非C调的情况下，当前音在五线谱中应该如何理解
    let result = note
    const noteObj = Note.get(note);
    const scale = Key.majorKey(key).scale;
    const scaleNote = scale.find(v => Note.get(v).letter === noteObj.letter);
    if (Note.get(scaleNote as string).acc) {
        const scaleAcc = Note.get(scaleNote as string).acc
        const answerAcc = noteObj.acc;
        if (scaleAcc === '#') {
            if (answerAcc === '#') {
                result = noteObj.letter + noteObj.oct;
            }
            if (answerAcc === 'b') {
                result = noteObj.letter + 'b' + noteObj.oct;
            }
            if (!answerAcc) {
                result = noteObj.letter + '#' + noteObj.oct;
            }
        }
        if (scaleAcc === 'b') {
            if (answerAcc === '#') {
                result = noteObj.letter + '#' + noteObj.oct;
            }
            if (answerAcc === 'b') {
                result = noteObj.letter + noteObj.oct;
            }
            if (!answerAcc) {
                result = noteObj.letter + 'b' + noteObj.oct;
            }
        }
    }
    return result
}

export const majorTrans = (note: string, key: string) => {
    if (!note) {
        return '';
    }
    // 带有升降号的音在非C调的情况下应该如何显示升降号
    let answer = note;
    const answerObj = Note.get(note);
    const scale = Key.majorKey(key).scale;
    const scaleNote = scale.find(v => Note.get(v).letter === answerObj.letter);
    if (Note.get(scaleNote as string).acc) {
        const scaleAcc = Note.get(scaleNote as string).acc
        const answerAcc = answerObj.acc;
        if (scaleAcc === '#') {
            if (answerAcc === '#') {
                answer = answerObj.letter + answerObj.oct;
            }
            if (answerAcc === 'b') {
                answer = answerObj.letter + 'b' + answerObj.oct;
            }
            if (!answerAcc) {
                answer = answerObj.letter + 'n' + answerObj.oct;
            }
        }
        if (scaleAcc === 'b') {
            if (answerAcc === '#') {
                answer = answerObj.letter + '#' + answerObj.oct;
            }
            if (answerAcc === 'b') {
                answer = answerObj.letter + answerObj.oct;
            }
            if (!answerAcc) {
                answer = answerObj.letter + 'n' + answerObj.oct;
            }
        }
    }
    return answer
}


// 音程题随机参数
const getRandom = (arr: Array<any>) => arr[Math.floor(Math.random() * arr.length)];
const basicNotes = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];
const yinChengTypes = ['M', 'm', 'P', 'A', 'd'];
const mSteps = [2, 3, 6, 7];
const pSteps = [4, 5, 8];
const aSteps = [2, 3, 4, 5, 6, 7, 8];
const nums = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; // 随机音程
const DI_YIN = 0; // 低音
const GAO_YIN = 1; // 高音
const baseNoteTypes = [DI_YIN, GAO_YIN]; // 题目给出音程的类型，低音 / 高音
const keys = ['C', 'C#', 'D', 'E', 'F#', 'G', 'A', 'B', 'Db', 'Eb', 'F', 'Gb', 'Ab', 'Bb', 'Cb'];

// 和弦题随机参数
const heXianTypes = ['M', 'm', 'A', 'd',
    'DaXiaoQi', 'DaQi', 'XiaoQi', 'JianQi',
    'JianXiaoQi', 'ZengDaQi', 'XiaoDaQi']; // 大、小、增、减

const yinChengTypeMatch = (str: string) => {
    switch (str) {
        case 'M':
            return '大'
        case 'm':
            return '小'
        case 'P':
            return '纯'
        case 'A':
            return '增'
        case 'd':
            return '减'
    }
}

const heXianTypeMatch = (str: string) => {
    switch (str) {
        case 'M':
            return '大三和弦'
        case 'm':
            return '小三和弦'
        case 'P':
            return '纯三和弦'
        case 'A':
            return '增三和弦'
        case 'd':
            return '减三和弦'
        case 'DaXiaoQi':
            return '大小七和弦'
        case 'DaQi':
            return '大七和弦'
        case 'XiaoQi':
            return '小七和弦'
        case 'JianQi':
            return '减七和弦'
        case 'JianXiaoQi':
            return '减小七和弦'
        case 'ZengDaQi':
            return '增大七和弦'
        case 'XiaoDaQi':
            return '小大七和弦'
    }
}

const stepMatch = (step: number) => {
    return ['一', '二', '三', '四', '五', '六', '七', '八'][step - 1]
}

export const majorT = (note: string, key: string, cToOther: boolean) => {
    const targetScale = Key.majorKey(key).scale;
    const isMajor = targetScale.filter(i => i.includes('#')).length !== 0;
    const interval = distance('C', key);
    if (cToOther) {
        return transpose(note, interval);
    } else {
        const noteParsed = parseNote(note);
        const key = noteParsed.letter;
        const octave = noteParsed.oct;
        const accidentals = noteParsed.accidentals
        const baseNote = `${key}${accidentals}${octave}`;
        // 找到升降号出现变化的音
        const template = targetScale.filter(note => note.length === 2);
        // 上述的音是否影响了当前音
        let flag = false;
        let transNote: any = '';
        template.forEach((note) => {
            if (note.indexOf(key) !== -1) {
                flag = true;
            }
        })
        if (flag) {
            if (accidentals !== '') {
                // 先还原
                const noteRestore = `${key}${octave}`;
                if (isMajor) { // 升号大调
                    if (accidentals === 'n') {
                        transNote = transpose(noteRestore, `-${interval}`);
                    }
                    if (accidentals === 'b') {
                        transNote = transpose(`${key}b${octave}`, `-${interval}`);
                    }
                    if (accidentals === '##') {
                        transNote = transpose(`${key}##${octave}`, `-${interval}`);
                    }
                    if (accidentals === '#') {
                        transNote = transpose(baseNote, `-${interval}`);
                    }
                } else { // 降号大调
                    if (accidentals === 'n') {
                        transNote = transpose(noteRestore, `-${interval}`);
                    }
                    if (accidentals === '#') {
                        transNote = transpose(`${key}#${octave}`, `-${interval}`);
                    }
                    if (accidentals === 'bb') {
                        transNote = transpose(`${key}bb${octave}`, `-${interval}`);
                    }
                    if (accidentals === 'b') {
                        transNote = transpose(baseNote, `-${interval}`);
                    }
                }
            } else {
                if (isMajor) {
                    transNote = transpose(`${key}#${octave}`, `-${interval}`);
                } else {
                    transNote = transpose(`${key}b${octave}`, `-${interval}`);
                }
            }
        } else {
            // 正常转化
            let note = `${key}${accidentals}${octave}`;
            if (accidentals === 'n') {
                note = `${key}${octave}`;
            }
            note = Note.simplify(note);
            transNote = transpose(note, `-${interval}`);
        }
        return transNote
    }
}

export const questionGenerate = (type: string) => {
    const key = getRandomKeyByAccidentals(keys);
    if (type === 'YinCheng' || type === 'SelectionYinCheng') {
        const baseNote = getRandom(basicNotes);
        const yinChengType = getRandom(yinChengTypes);
        let answer;

        const getStep = (yinChengType: string) => {
            let step = 0;
            if (yinChengType === 'M' || yinChengType === 'm') {
                step = getRandom(mSteps);
            } else if (yinChengType === 'P') {
                step = getRandom(pSteps);
            } else {
                step = getRandom(aSteps);
            }
            return step;
        }

        const step = getStep(yinChengType);

        let oct = 4;
        const baseNoteType = getRandom(baseNoteTypes);
        if (baseNoteType === GAO_YIN) {
            oct = 5;
        }
        // 计算答案
        let startNote = `${baseNote}${oct}`;
        if (key !== 'C') {
            startNote = noteAccInMajor(startNote, key);
        }
        if (baseNoteType === DI_YIN) {
            answer = transpose(startNote, `${step}${yinChengType}`)
        } else {
            answer = transpose(startNote, `-${step}${yinChengType}`)
        }
        if (answer.length >= 5) {
            answer = Note.simplify(answer);
        }
        const answerBeforeTrans = answer;
        if (key !== 'C') {
            answer = majorTrans(answer, key);
        }
        let content = `以题目中给出的音为${baseNoteType === GAO_YIN ? '冠音' : '底音'}向${baseNoteType === GAO_YIN ? '下' : '上'}构建${yinChengTypeMatch(yinChengType)}${stepMatch(step)}度音程`

        const options = [];
        if (type === 'SelectionYinCheng') {
            // 生成错误选项
            let answerObj = Note.get(answer);
            let answerAcc = answerObj.acc;
            if (answer[1] === 'n') {
                answerAcc = 'n';
                answerObj = Note.get(`${answer.slice(0, 1)}${answer.slice(-1)}`)
            }
            const scaleKeys = Key.majorKey(key).scale;
            let keyAcc = '';
            scaleKeys.forEach(item => {
                const obj = Note.get(item)
                if (obj.acc !== '') {
                    keyAcc = obj.acc;
                }
            })
            const answerInScale = scaleKeys.filter(note => Note.get(note).letter === answerObj.letter)[0];
            const accs = [];

            if (!answerAcc) {
                // 原音符没有升降号
                if (key === 'C') {
                    accs.push('#', 'b', '##', 'bb');
                } else {
                    const _acc = Note.get(answerInScale).acc;
                    if (_acc === '') {
                        if (keyAcc === '#') {
                            accs.push('##', '#', 'b')
                        } else {
                            accs.push('b', 'bb', '#');
                        }
                    } else if (_acc === '#') {
                        accs.push('n', '##', 'b');
                    } else if (_acc === 'b') {
                        accs.push('n', 'bb', '#');
                    }
                }
            } else if (answerAcc === '#') {
                if (key === 'C') {
                    accs.push('##', 'b', 'bb', '');
                } else {
                    if (keyAcc === '#') {
                        accs.push('##', 'b', '');
                    } else {
                        accs.push('bb', 'n', '');
                    }
                }
            } else if (answerAcc === 'b') {
                if (key === 'C') {
                    accs.push('##', '#', 'bb', '');
                } else {
                    if (keyAcc === '#') {
                        accs.push('##', 'n', '');
                    } else {
                        accs.push('bb', '#', '');
                    }
                }
            } else if (answerAcc === 'n') {
                if (keyAcc === '#') {
                    accs.push('##', 'b', '');
                }
                if (keyAcc === 'b') {
                    accs.push('bb', '#', '');
                }
            } else if (answerAcc === '##') {
                if (key === 'C') {
                    accs.push('b', '#', 'bb', '');
                } else {
                    if (keyAcc === '#') {
                        accs.push('b', 'n', 'bb', '');
                    }
                    if (keyAcc === 'b') {
                        accs.push('#', 'n', 'bb', '');
                    }
                }
            } else if (answerAcc === 'bb') {
                if (key === 'C') {
                    accs.push('b', '#', '##', '');
                } else {
                    if (keyAcc === '#') {
                        accs.push('##', 'n', 'b', '');
                    }
                    if (keyAcc === 'b') {
                        accs.push('##', 'n', '#', '');
                    }
                }
            }
            getRandomN(accs, 3).forEach(acc => {
                options.push([`${answerObj.letter}${acc}/${answerObj.oct}`]);
            });
            content = `以下题目中，哪一个是${yinChengTypeMatch(yinChengType)}${stepMatch(step)}度音程`;
        }

        return {
            type: yinChengType,
            step,
            baseNote: [`${baseNote}/${oct}`],
            content,
            baseNoteType,
            answerBeforeTrans,
            answer: answer.slice(0, -1) + '/' + answer.slice(-1),
            key,
            options,
            choose: getRandom(['A', 'B', 'C', 'D']),
        }
    }

    if (type === 'HeXian' || type === 'SelectionHeXian') {
        /*
        * 数字对应音程
        * 0: 1P
        * 1: 2m
        * 2: 2M
        * 3: 3m
        * 4: 3M
        * 5: 4P
        * 6: 5d
        * 7: 5P
        * 8: 6m
        * 9: 6M
        * 10: 7m
        * 11: 7M
        * */
        let oct = Math.random() > 0.5 ? 5 : 4;
        const randomNote = getRandom(basicNotes);
        if (['E', 'F', 'G', 'A', 'B'].indexOf(randomNote) !== -1) {
            oct = 4;
        }
        const heXianType = getRandom(heXianTypes);
        const translocation = ['YuanWei', 'YiZhuan', 'ErZhuan']; // 原位、第一转位、第二转位
        if (['M', 'm', 'A', 'd'].indexOf(heXianType) === -1) {
            translocation.push('SanZhuan');
        }
        const transStr = { 'YuanWei': '原位', 'YiZhuan': '第一转位', 'ErZhuan': '第二转位', 'SanZhuan': '第三转位' }
        const trans = getRandom(translocation);
        if (['M', 'm', 'A', 'd'].indexOf(heXianType) !== -1) {
            if (trans === 'YiZhuan') {
                oct = 5;
            }
        } else {
            if (trans !== 'YuanWei' && trans !== 'SanZhuan') {
                oct = 5;
            }
            if (trans === 'SanZhuan') {
                oct = 4;
            }
        }
        let content = `以题目中的音为${trans === 'YuanWei' ? '低音' : '根音'}，构建一个${trans === 'YuanWei' ? '原位' : ''}${heXianTypeMatch(heXianType)}${trans !== 'YuanWei' ? transStr[trans] : ''}`;
        let secondNote = '';
        let thirdNote = '';
        let fourthNote = '';
        let startNote = `${randomNote}${oct}`;
        if (key !== 'C') {
            startNote = noteAccInMajor(startNote, key);
        }

        [secondNote, thirdNote, fourthNote] = generateHeXian(heXianType, trans, startNote);

        const answerBeforeTrans = [secondNote, thirdNote, fourthNote];

        if (key !== 'C') {
            secondNote = majorTrans(secondNote, key);
            thirdNote = majorTrans(thirdNote, key);
            fourthNote = majorTrans(fourthNote, key);
        }

        const options = [];
        if (type === 'SelectionHeXian') {
            content = `以下题目中，哪一个是${heXianTypeMatch(heXianType)}${transStr[trans]}`;
            let _types = []
            if (['M', 'm', 'A', 'd'].indexOf(heXianType) !== -1) {
                // 如果是三和弦
                _types = ['M', 'm', 'A', 'd'].filter(v => v !== heXianType);
            } else {
                // 七和弦
                _types = ['DaXiaoQi', 'DaQi', 'XiaoQi', 'JianQi', 'JianXiaoQi', 'ZengDaQi', 'XiaoDaQi'].filter(v => v !== heXianType);
            }
            // 取出随机三个其他类型的 三和弦 / 七和弦
            _types = shuffleArray(getRandomN(_types, 3));
            _types.forEach(_type => {
                let [note1, note2, note3] = generateHeXian(_type, trans, startNote);
                [note1, note2, note3] = [note1, note2, note3].map(note => {
                    if (note.length >= 5) {
                        return Note.simplify(note);
                    }
                    return note;
                })
                if (key !== 'C') {
                    note1 = majorTrans(note1, key);
                    note2 = majorTrans(note2, key);
                    note3 = majorTrans(note3, key);
                }
                options.push([note1, note2, note3].filter(v => v).map(v => v.slice(0, -1) + '/' + v.slice(-1)));
            });
        }

    return {
        baseNote: [`${randomNote}/${oct}`],
        heXianType,
        trans,
        content,
        answerBeforeTrans: answerBeforeTrans.filter(v => v && v.length > 0),
        answer: [secondNote, thirdNote, fourthNote].filter(v => v && v.length > 0).map(i => i.slice(0, -1) + '/' + i.slice(-1)),
        key,
        choose: getRandom(['A', 'B', 'C', 'D']),
        options
    }
    }

    if (type === 'YinJie' || type === 'SelectionYinJie') {
        // console.log(ScaleType.all())
        // console.log(Scale.get('G4 minor'))
        // const degree = Scale.degrees('G4 mixolydian');
        // console.log(degree(-1))
        const yinJieMajors = ['ZiRanDa', 'ZiRanXiao', 'HeShengDa', 'HeShengXiao', 'XuanLvDa', 'XuanLvXiao',
            'YiAoNiYa', 'DuoLiYa', 'FuLiJiYa', 'LiDiYa', 'HunHeLiDiYa', 'AiAoNiYa', 'LuoKeLiYa',
            'Gong', 'Shang', 'Jiao', 'Zhi', 'Yu'];
        const major = getRandom(yinJieMajors);
        let acc = getRandom(['#', 'b', '']);
        if (type === 'SelectionYinJie') acc = '';
        const oct = Math.random() > 0.5 ? 5 : 4;
        let randomNote = getRandom(basicNotes);
        // 控制一下显示的范围，避免显示过高或者过低
        if (oct === 5 && major !== 'XuanLvDa') {
            randomNote = getRandom(['C', 'D'])
        }
        if (oct === 4 && major === 'XuanLvDa') {
            randomNote = getRandom(['F', 'G', 'A', 'B'])
        }
        const baseNote = `${randomNote}${acc}${oct}`;

        let answer: string[] = []
        let intervals: string[] = []
        let name = ''

        if (major === 'XuanLvDa') {
            name = '旋律大调';
            intervals = ['-2M', '-3M', '-4P', '-5P', '-6m', '-7m', '-8P'];
            intervals.forEach(interval => answer.push(transpose(baseNote, interval)));
        } else if (['Gong', 'Shang', 'Jiao', 'Zhi', 'Yu'].indexOf(major) !== -1) {
            if (major === 'Gong') {
                name = '宫调式';
                intervals = ['2M', '3M', '5P', '6M', '8P'];
            }
            if (major === 'Shang') {
                name = '商调式';
                intervals = ['2M', '4P', '5P', '7m', '8P'];
            }
            if (major === 'Jiao') {
                name = '角调式';
                intervals = ['3m', '4P', '6m', '7m', '8P'];
            }
            if (major === 'Zhi') {
                name = '徵调式';
                intervals = ['2M', '4P', '5P', '6M', '8P'];
            }
            if (major === 'Yu') {
                name = '羽调式';
                intervals = ['3m', '4P', '5P', '7m', '8P'];
            }
            intervals.forEach(interval => answer.push(transpose(baseNote, interval)));
        } else {
            let src = ''
            if (major === 'ZiRanDa') {
                name = '自然大调';
                src = `${baseNote} major`;
            }
            if (major === 'ZiRanXiao') {
                name = '自然小调';
                src = `${baseNote} minor`;
            }
            if (major === 'HeShengDa') {
                name = '和声大调';
                src = `${baseNote} harmonic major`;
            }
            if (major === 'HeShengXiao') {
                name = '和声小调';
                src = `${baseNote} harmonic minor`;
            }
            if (major === 'XuanLvDa') {
                name = '旋律大调';
                src = `${baseNote} harmonic minor`;
            }
            if (major === 'XuanLvXiao') {
                name = '旋律小调';
                src = `${baseNote} melodic minor`;
            }
            if (major === 'YiAoNiYa') {
                name = '伊奥尼亚调式';
                src = `${baseNote} ionian`;
            }
            if (major === 'DuoLiYa') {
                name = '多利亚调式';
                src = `${baseNote} dorian`;
            }
            if (major === 'FuLiJiYa') {
                name = '弗几里亚调式';
                src = `${baseNote} phrygian`;
            }
            if (major === 'LiDiYa') {
                name = '利底亚调式';
                src = `${baseNote} lydian`;
            }
            if (major === 'HunHeLiDiYa') {
                name = '混合利底亚调式';
                src = `${baseNote} mixolydian`;
            }
            if (major === 'AiAoNiYa') {
                name = '爱奥尼亚调式';
                src = `${baseNote} aeolian`;
            }
            if (major === 'LuoKeLiYa') {
                name = '洛克里亚调式';
                src = `${baseNote} locrian`;
            }
            const scale = Scale.get(src).notes;
            answer = scale.concat(transpose(baseNote, '8P')).slice(1);
        }
        let content = `从题目中给出的音开始，${major === 'XuanLvDa' ? '下行' : ''}写出${name}音阶`

        const options = [];
        if (type === 'SelectionYinJie') {
            const originalNotes = [...answer];
            content = `以下选项中，哪一个是${name}音阶`;
            /*
            * 生成选项思路：
            * 1. 保持音符
            * 2. 随机升降号
            * */

            // 定义一个函数来确定当前数组的升降号风格
            function determineAccidentalStyle(notes) {
                let acc = '';
                notes.forEach(v => {
                    if (v.includes('#')) {
                        acc = '#';
                    }
                    if (v.includes('b')) {
                        acc = 'b';
                    }
                })
                return acc ? acc : Math.random() < 0.5 ? 'b' : '#'; // 随机选择一种风格
            }

            // 定义一个函数来随机选择一个音符并添加或去掉升降号
            function modifyOneNote(notes, accidentalStyle) {
                const modifiedNotes = [...notes]; // 复制原数组
                const randomIndex = Math.floor(Math.random() * modifiedNotes.length); // 随机选择一个音符
                const note = modifiedNotes[randomIndex];

                // 检查音符是否已经有升降号
                if (note.length === 2) {
                    // 没有升降号，添加当前风格的升降号
                    modifiedNotes[randomIndex] = note[0] + accidentalStyle + note[1];
                } else {
                    // 已经有升降号，去掉它
                    modifiedNotes[randomIndex] = note[0] + note[2];
                }

                return modifiedNotes;
            }

            // 确定当前数组的升降号风格
            const accidentalStyle = determineAccidentalStyle(originalNotes);

            // 使用 Set 来存储生成的数组，确保不重复
            const generatedArrays = new Set([JSON.stringify(originalNotes)]); // 将原始数组加入集合
            const targetCount = 4; // 目标生成的数组数量
            const maxAttempts = 1000; // 防止无限循环
            let attempts = 0;

            while (generatedArrays.size < targetCount && attempts < maxAttempts) {
                const newNotes = modifyOneNote(originalNotes, accidentalStyle);
                const newNotesString = JSON.stringify(newNotes);
                if (!generatedArrays.has(newNotesString)) {
                    generatedArrays.add(newNotesString);
                }
                attempts++;
            }

            [...generatedArrays].slice(1).forEach(notes => {
                options.push(
                    JSON.parse(notes).map(v => [v.slice(0, -1) + '/' + v.slice(-1)])
                )
            })
        }
        return {
            key,
            baseNote: [`${randomNote}${acc}/${oct}`],
            major,
            content,
            answer: answer.map(i => [i.slice(0, -1) + '/' + i.slice(-1)]),
            choose: getRandom(['A', 'B', 'C', 'D']),
            options
        }
    }
    if (type === 'LianErDanYin') {
        const randomNum = Math.random();
        const acc = randomNum > 0.8 ? '#' : randomNum < 0.2 ? 'b' : '';
        const oct = randomNum > 0.5 ? 4 : 5;
        const randomNote = getRandom(basicNotes);
        const content = ''
        return {
            key,
            content,
            // baseNote: [randomNote + `${acc}/${oct}`],
            baseNote: [],
            answer: [randomNote + `${acc}/${oct}`]
        }
    }
    if (type === 'LianErYinCheng') {
        const baseNote = getRandom(basicNotes);
        // const acc = randomNum > 0.8 ? '#' : randomNum < 0.2 ? 'b' : '';
        // const oct = randomNum > 0.5 ? 4 : 5;
        const oct = 4;
        const interval = mapNumberToInterval(getRandom(nums));
        const secondNote = Note.simplify(transpose(`${baseNote}${oct}`, interval));
        const content = ''
        return {
            key,
            content,
            // baseNote: [`${baseNote}/${oct}`, secondNote.slice(0, -1) + '/' + secondNote.slice(-1)],
            baseNote: [],
            answer: [`${baseNote}${oct}`, secondNote].map(i => i.slice(0, -1) + '/' + i.slice(-1))
        }
    }
    if (type === 'LianErHeXian') {
        const randomNum = Math.random();
        // const acc = randomNum > 0.8 ? '#' : randomNum < 0.2 ? 'b' : '';
        let oct = randomNum > 0.5 ? 4 : 5;
        const heXians = ['M', 'm', 'A', 'd', 'DaXiaoQi', 'JianQi'];
        const heXianType = getRandom(heXians);
        const translocations = ['YuanWei', 'YiZhuan', 'ErZhuan'];
        if (['M', 'm', 'A', 'd'].indexOf(heXianType) === -1) {
            translocations.push('SanZhuan');
        }
        const trans = getRandom(translocations);
        const baseNote = getRandom(basicNotes) + `${oct}`;
        let secondNote = '';
        let thirdNote = '';
        let fourthNote = '';

        [secondNote, thirdNote, fourthNote] = generateHeXian(heXianType, trans, baseNote)

        const answer = [baseNote, secondNote, thirdNote, fourthNote]
            .filter(v => v && v.length > 0)
            .map(i => i.length === 4 ? Note.simplify(i) : i)
            .map(i => i.slice(0, -1) + '/' + i.slice(-1));
        return {
            key,
            baseNote: [],
            content: '',
            answer,
            heXianType,
            trans,
        }
    }

    return ''
}

function getRandomKeyByAccidentals(keys: string[]) {
    // 获取每个调号中的升降号数量
    function getKeyAccidentals(key: string) {
        // 使用 Tonal.js 获取调号信息
        const scale = Scale.get(`${key} major`);
        if (!scale.empty) {
            return scale.notes.reduce((count, note) => {
                if (note.includes('#') || note.includes('b')) {
                    count++;
                }
                return count;
            }, 0);
        }
        return 0;
    }

    // 将调号按升降号数量分类
    const keyCategories: any = {
        C: [], // 无升降号 (60%)
        simple: [], // 1-4个升降号 (30%)
        complex: [] // 5-7个升降号 (10%)
    };

    // 分类所有调号
    keys.forEach(key => {
        const accCount = getKeyAccidentals(key);
        if (accCount === 0) {
            keyCategories.C.push(key);
        } else if (accCount >= 1 && accCount <= 4) {
            keyCategories.simple.push(key);
        } else {
            keyCategories.complex.push(key);
        }
    });

    // 生成随机数
    const random = Math.random() * 100;

    // 根据概率选择类别
    let category;
    if (random < 60) {
        category = 'C';
    } else if (random < 90) {
        category = 'simple';
    } else {
        category = 'complex';
    }

    // 从选中的类别中随机选择一个调号
    const categoryKeys = keyCategories[category];
    if (categoryKeys.length === 0) return null;

    const randomIndex = Math.floor(Math.random() * categoryKeys.length);
    return categoryKeys[randomIndex];
}

// 根据权重随机获取数组中的某个值
function weightedRandom(values: Array<string>, weights: Array<number>) {
    // 确保values和weights的长度相同
    if (values.length !== weights.length) {
        throw new Error('Values and weights must have the same length.');
    }

    // 计算权重的总和
    let totalWeight = weights.reduce((sum, weight) => sum + weight, 0);

    // 生成一个0到总权重之间的随机数
    let random = Math.random() * totalWeight;

    // 累加权重，直到随机数小于当前的累加权重
    let cumulativeWeight = 0;
    for (let i = 0; i < values.length; i++) {
        cumulativeWeight += weights[i];
        if (random < cumulativeWeight) {
            return values[i];
        }
    }

    // 如果没有找到匹配的值（理论上不应该发生），则返回最后一个值
    return values[values.length - 1];
}

const generateHeXian = (heXianType: string, trans: string, startNote: string) => {
    let secondNote = '';
    let thirdNote = '';
    let fourthNote = '';

    // 和弦转位的弦内音计算，需要把根音降低一个八度
    const _startNote = transpose(startNote, '-8P');

    if (heXianType === 'M') {
        // 大三和弦
        if (trans === 'YuanWei') {
            secondNote = transpose(startNote, '3M');
            thirdNote = transpose(startNote, '5P');
        }
        if (trans === 'YiZhuan') {
            secondNote = transpose(_startNote, '3M');
            thirdNote = transpose(_startNote, '5P');
        }
        if (trans === 'ErZhuan') {
            secondNote = transpose(startNote, '3M');
            thirdNote = transpose(startNote, '5P');
            thirdNote = transpose(thirdNote, '-8P');
        }
    }
    if (heXianType === 'm') {
        // 小三和弦
        if (trans === 'YuanWei') {
            secondNote = transpose(startNote, '3m');
            thirdNote = transpose(startNote, '5P');
        }
        if (trans === 'YiZhuan') {
            secondNote = transpose(_startNote, '3m');
            thirdNote = transpose(_startNote, '5P');
        }
        if (trans === 'ErZhuan') {
            secondNote = transpose(startNote, '3m');
            thirdNote = transpose(startNote, '5P');
            thirdNote = transpose(thirdNote, '-8P');
        }
    }
    if (heXianType === 'A') {
        // 增三和弦
        if (trans === 'YuanWei') {
            secondNote = transpose(startNote, '3M');
            thirdNote = transpose(startNote, '5A');
        }
        if (trans === 'YiZhuan') {
            secondNote = transpose(_startNote, '3M');
            thirdNote = transpose(_startNote, '5A');
        }
        if (trans === 'ErZhuan') {
            secondNote = transpose(startNote, '3M');
            thirdNote = transpose(startNote, '5A');
            thirdNote = transpose(thirdNote, '-8P');
        }
    }
    if (heXianType === 'd') {
        // 减三和弦
        if (trans === 'YuanWei') {
            secondNote = transpose(startNote, '3m');
            thirdNote = transpose(startNote, '5d');
        }
        if (trans === 'YiZhuan') {
            secondNote = transpose(_startNote, '3m');
            thirdNote = transpose(_startNote, '5d');
        }
        if (trans === 'ErZhuan') {
            secondNote = transpose(startNote, '3m');
            thirdNote = transpose(startNote, '5d');
            thirdNote = transpose(thirdNote, '-8P');
        }
    }
    if (heXianType === 'DaXiaoQi') {
        // 大小七和弦
        if (trans === 'YuanWei') {
            secondNote = transpose(startNote, '3M');
            thirdNote = transpose(startNote, '5P');
            fourthNote = transpose(startNote, '7m');
        }
        if (trans === 'YiZhuan') {
            secondNote = transpose(_startNote, '3M');
            thirdNote = transpose(_startNote, '5P');
            fourthNote = transpose(_startNote, '7m');
        }
        if (trans === 'ErZhuan') {
            secondNote = transpose(startNote, '3M');
            thirdNote = transpose(_startNote, '5P');
            fourthNote = transpose(_startNote, '7m');
        }
        if (trans === 'SanZhuan') {
            secondNote = transpose(startNote, '3M');
            thirdNote = transpose(startNote, '5P');
            fourthNote = transpose(_startNote, '7m');
        }
    }
    if (heXianType === 'DaQi') {
        // 大七和弦
        if (trans === 'YuanWei') {
            secondNote = transpose(startNote, '3M');
            thirdNote = transpose(startNote, '5P');
            fourthNote = transpose(startNote, '7M');
        }
        if (trans === 'YiZhuan') {
            secondNote = transpose(_startNote, '3M');
            thirdNote = transpose(_startNote, '5P');
            fourthNote = transpose(_startNote, '7M');
        }
        if (trans === 'ErZhuan') {
            secondNote = transpose(startNote, '3M');
            thirdNote = transpose(_startNote, '5P');
            fourthNote = transpose(_startNote, '7M');
        }
        if (trans === 'SanZhuan') {
            secondNote = transpose(startNote, '3M');
            thirdNote = transpose(startNote, '5P');
            fourthNote = transpose(_startNote, '7M');
        }
    }
    if (heXianType === 'XiaoQi') {
        // 小七和弦
        if (trans === 'YuanWei') {
            secondNote = transpose(startNote, '3m');
            thirdNote = transpose(startNote, '5P');
            fourthNote = transpose(startNote, '7m');
        }
        if (trans === 'YiZhuan') {
            secondNote = transpose(_startNote, '3m');
            thirdNote = transpose(_startNote, '5P');
            fourthNote = transpose(_startNote, '7m');
        }
        if (trans === 'ErZhuan') {
            secondNote = transpose(startNote, '3m');
            thirdNote = transpose(_startNote, '5P');
            fourthNote = transpose(_startNote, '7m');
        }
        if (trans === 'SanZhuan') {
            secondNote = transpose(startNote, '3m');
            thirdNote = transpose(startNote, '5P');
            fourthNote = transpose(_startNote, '7m');
        }
    }
    if (heXianType === 'JianQi') {
        // 减七和弦
        if (trans === 'YuanWei') {
            secondNote = transpose(startNote, '3m');
            thirdNote = transpose(startNote, '5d');
            fourthNote = transpose(startNote, '7d');
        }
        if (trans === 'YiZhuan') {
            secondNote = transpose(_startNote, '3m');
            thirdNote = transpose(_startNote, '5d');
            fourthNote = transpose(_startNote, '7d');
        }
        if (trans === 'ErZhuan') {
            secondNote = transpose(startNote, '3m');
            thirdNote = transpose(_startNote, '5d');
            fourthNote = transpose(_startNote, '7d');
        }
        if (trans === 'SanZhuan') {
            secondNote = transpose(startNote, '3m');
            thirdNote = transpose(startNote, '5d');
            fourthNote = transpose(_startNote, '7d');
        }
    }
    if (heXianType === 'JianXiaoQi') {
        // 减小七和弦
        if (trans === 'YuanWei') {
            secondNote = transpose(startNote, '3m');
            thirdNote = transpose(startNote, '5d');
            fourthNote = transpose(startNote, '7m');
        }
        if (trans === 'YiZhuan') {
            secondNote = transpose(_startNote, '3m');
            thirdNote = transpose(_startNote, '5d');
            fourthNote = transpose(_startNote, '7m');
        }
        if (trans === 'ErZhuan') {
            secondNote = transpose(startNote, '3m');
            thirdNote = transpose(_startNote, '5d');
            fourthNote = transpose(_startNote, '7m');
        }
        if (trans === 'SanZhuan') {
            secondNote = transpose(startNote, '3m');
            thirdNote = transpose(startNote, '5d');
            fourthNote = transpose(_startNote, '7m');
        }
    }
    if (heXianType === 'ZengDaQi') {
        // 增大七和弦
        if (trans === 'YuanWei') {
            secondNote = transpose(startNote, '3M');
            thirdNote = transpose(startNote, '5A');
            fourthNote = transpose(startNote, '7M');
        }
        if (trans === 'YiZhuan') {
            secondNote = transpose(_startNote, '3M');
            thirdNote = transpose(_startNote, '5A');
            fourthNote = transpose(_startNote, '7M');
        }
        if (trans === 'ErZhuan') {
            secondNote = transpose(startNote, '3M');
            thirdNote = transpose(_startNote, '5A');
            fourthNote = transpose(_startNote, '7M');
        }
        if (trans === 'SanZhuan') {
            secondNote = transpose(startNote, '3M');
            thirdNote = transpose(startNote, '5A');
            fourthNote = transpose(_startNote, '7M');
        }
    }
    if (heXianType === 'XiaoDaQi') {
        // 大小七和弦
        if (trans === 'YuanWei') {
            secondNote = transpose(startNote, '3m');
            thirdNote = transpose(startNote, '5P');
            fourthNote = transpose(startNote, '7M');
        }
        if (trans === 'YiZhuan') {
            secondNote = transpose(_startNote, '3m');
            thirdNote = transpose(_startNote, '5P');
            fourthNote = transpose(_startNote, '7M');
        }
        if (trans === 'ErZhuan') {
            secondNote = transpose(startNote, '3m');
            thirdNote = transpose(_startNote, '5P');
            fourthNote = transpose(_startNote, '7M');
        }
        if (trans === 'SanZhuan') {
            secondNote = transpose(startNote, '3m');
            thirdNote = transpose(startNote, '5P');
            fourthNote = transpose(_startNote, '7M');
        }
    }

    return [secondNote, thirdNote, fourthNote]
}
